import type { Customer } from '../api/customersApi';
import { dateKey, matches, startOfStoreDay } from '../../../shared/lib/format';
export function inactiveCustomer(customer: Customer, today: string, timezone: string) {
  return customer.status === 'inactive' || (customer.last_visit_at !== undefined && startOfStoreDay(today, timezone) - customer.last_visit_at >= 30 * 86400000);
}
export function filterCustomers(customers: Customer[], options: { q: string; group: string; lastVisit: string; spend: string; sort: string; today: string; timezone: string; locale?: string }) {
  const { q, group, lastVisit, spend, sort, today, timezone } = options;
  return customers.filter(c => {
    if (!matches(`${c.name || ''} ${c.phone || ''} ${c.customer_code || ''}`, q)) return false;
    if (group === 'vip' && !(c.vip_tier && c.vip_tier > 0)) return false;
    if (group === 'returning' && !(c.visits !== undefined && c.visits > 1)) return false;
    if (group === 'new' && !(c.visits !== undefined && c.visits <= 1)) return false;
    if (group === 'inactive' && !inactiveCustomer(c, today, timezone)) return false;
    if (lastVisit !== 'any') {
      if (c.last_visit_at === undefined) return false;
      if (lastVisit === 'today' && dateKey(c.last_visit_at, timezone) !== today) return false;
      if ((lastVisit === '7' || lastVisit === '30') && startOfStoreDay(today, timezone) - c.last_visit_at > Number(lastVisit) * 86400000) return false;
    }
    if (spend === 'high' && c.total_price < 5000000) return false;
    if (spend === 'medium' && (c.total_price < 1000000 || c.total_price >= 5000000)) return false;
    if (spend === 'low' && c.total_price >= 1000000) return false;
    return true;
  }).sort((a, b) => sort === 'name' ? (a.name || '').localeCompare(b.name || '', options.locale || 'vi-VN') : sort === 'visits' ? (b.visits ?? -1) - (a.visits ?? -1) : sort === 'newest' ? b.created_at - a.created_at : b.total_price - a.total_price);
}
export function lastVisitLabel(customer: Customer, today: string, timezone: string, locale = "vi-VN") {
  if (customer.last_visit_at === undefined) return '—';
  const days = Math.round((Date.parse(today) - Date.parse(dateKey(customer.last_visit_at, timezone))) / 86400000);
  return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(-Math.max(0, days), 'day');
}
